import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { EquipmentOption } from '../models/equipment.model';

@Component({
  selector: 'ds-equipment-checklist',
  templateUrl: './equipment-checklist.component.html',
  styleUrls: ['./equipment-checklist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EquipmentChecklistComponent {
  @Input() equipment: EquipmentOption;
  @Input() form: UntypedFormGroup;
  @Output() equipmentSelectEvent = new EventEmitter();

  @Input() optionCtrl: AbstractControl;

  constructor() {}

  toggleOption() {
    this.optionCtrl.setValue(!this.optionCtrl.value);
    this.equipment.selectedOption = this.optionCtrl.value;
    this.equipmentSelectEvent.emit(this.equipment);
  }
}
